import angular from 'angular';
import { videoAssociatedSessionNumber } from './ax.filters';

export default angular.module("ax.WebCommunications.filters", [])
  .filter("videoAssociatedSessionNumber", ["SessionService", videoAssociatedSessionNumber])
  .name;
